import { render, staticRenderFns } from "./gonetwork2.vue?vue&type=template&id=2cf95f3c&scoped=true&"
import script from "./gonetwork2.vue?vue&type=script&lang=js&"
export * from "./gonetwork2.vue?vue&type=script&lang=js&"
import style0 from "./gonetwork2.vue?vue&type=style&index=0&id=2cf95f3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf95f3c",
  null
  
)

export default component.exports